<template>
    <div class="chat-body-form-btn" :class="{'can-send': isActiveBtn}">
        <div class="chat-body-form-btn__emoji" :class="{'no-touch': disableBtnSmile, active: isShowEmojiMobile}" @click="toogleEmojiMobile">
            <svg v-once class="wc-i svg" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" x2="9.01" y1="9" y2="9"/><line x1="15" x2="15.01" y1="9" y2="9"/></svg>
            <div class="chat-body-form-btn__emoji-wrap" :class="{'no-touch': disableBtnSmile}">
                <EmojiPicker @add-emoji="addEmoji"/>
            </div>           
        </div>
        <button class="chat-body-form-btn__btn-send" :class="{'is-text': sendLabel}" :aria-label="sendLabel || (isEdit ? $t('Save') : 'Send text')" @click="clickBtnSend">
            <template v-if="sendLabel">{{ sendLabel }}</template>
            <svg v-if="isEdit" class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
            <svg v-else class="wc-i" aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z"/><path d="M6 12h16"/></svg>      
        </button> 
    </div>
</template>
  
<script>
import EmojiPicker from './EmojiPicker.vue';

  export default {
    components: {
      EmojiPicker,
    },
    data() {
      return {
        filesLocal: [],
        allowedTypes : [],
        isShowEmojiMobile: false
      };
    },
    props: {
      contentMsg: {
        type: String,
        default: ''
      },
      isActiveBtn: {
        type: Boolean,
        default: false
      },
      disableBtnSmile: {
        type: Boolean,
        default: false
      },
      isTablet: {
        type: Boolean,
        default: false
      },
      // Text button ("Send" / "Save") in the attachments dialog; icon button otherwise
      sendLabel: {
        type: String,
        default: ''
      },
      // Editing an existing message: the icon button saves instead of sending
      isEdit: {
        type: Boolean,
        default: false
      }
    },
    methods: {
        toogleEmojiMobile() {
            if(this.isTablet) this.isShowEmojiMobile = !this.isShowEmojiMobile;
        },
        addEmoji(emoji) {
            this.$emit('add-emoji', emoji)
        },
        clickBtnSend() {
            this.$emit('send-click')
        }
    },
  };
  </script>
  
<style lang="scss" scoped>
    .chat-body-form-btn{
        display: flex;
        align-items: flex-end;
        gap: 2px;
        // Send is always visible (design): grey until there is something to send
        &__btn-send{
            width: 32px;
            height: 32px;
            min-width: 32px;
            margin-left: 2px;
            padding: 0;
            border: 0;
            background-color: #EEF0F3;
            color: #6B7280;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: background-color 0.2s, color 0.2s;
            pointer-events: none;
            @media only screen and (max-width: 1023px) {
                width: 36px;
                height: 36px;
                min-width: 36px;
            }
            svg{
                width: 16px;
                height: 16px;
                path{
                    fill: currentColor;
                }
            }
        }
        &__emoji{
            padding: 0;
            transition: 0.2s;
            cursor: pointer;
            display: flex;
            align-items: center;
            position: relative;
            width: 32px;
            min-width: 32px;
            z-index: 2;
            height: 32px;
            border-radius: 8px;
            background-color: transparent;
            justify-content: center;
            @media only screen and (max-width: 1023px) {
                width: 36px;
                height: 36px;
                min-width: 36px;
            }
            .svg{
                width: 18px;
                height: 18px;
            }
            &.no-touch{
                opacity: 0.5;
                pointer-events: none;
            }
            &::after{
                z-index: 1;
                position: absolute;
                bottom: 0;
                height: 60px;
                width: 60px;
                right: 0;
                background-color: transparent;
                content: '';
                pointer-events: none;
                @media only screen and (max-width: 1023px) {
                    height: 100vh;
                    width: 100vh;
                    right: -50px;
                    bottom: -50px;
                }
            }
            .svg path{
                transition: 0.4s;
            }
            &-wrap{
                box-shadow: 0 12px 32px var(--wc-shadow-strong);
                border: 1px solid var(--wc-border);
                position: absolute;
                background-color: var(--wc-surface);
                border-radius: 12px;
                padding: 8px;
                pointer-events: none;
                opacity: 0;
                z-index: 10;
                bottom: calc(100% + 14px);
                right: -46px;
                transition: 
                opacity 0.4s ease,
                transform 0.4s cubic-bezier(.2,.8,.2,1);
                max-height: 296px;
                overflow-y: auto;
                overscroll-behavior: contain;
                transform: scale(0.5);
                transform-origin: bottom right;
            }
            &.active{
                background-color: var(--wc-accent-soft);
                &::after,
                .chat-body-form-btn__emoji-wrap{
                    opacity: 1;
                    transform: scale(1);
                    pointer-events: all;
                }
                .svg path{
                    fill: var(--wc-accent);
                }
            }
            &:hover{
                @media only screen and (min-width: 1024px) {
                    background-color: var(--wc-accent-soft);
                    &::after,
                    .chat-body-form-btn__emoji-wrap{
                        opacity: 1;
                        transform: scale(1);
                        pointer-events: all;
                    }
                    .svg path{
                        fill: var(--wc-accent);
                    }
                }
            }
        }
        &__btn-send.is-text{
            width: auto;
            min-width: 0;
            height: 36px;
            padding: 0 14px;
            font-family: var(--wc-font-medium);
            font-size: 13px;
            line-height: 18px;
            white-space: nowrap;
            svg{
                display: none;
            }
        }
        &.can-send{
            .chat-body-form-btn__btn-send{
                background-color: #2F6BE6;
                color: var(--wc-on-accent);
                pointer-events: all;
                cursor: pointer;
                &:hover{
                    background-color: var(--wc-accent);
                }
            }
        }
    }
</style>